/** Data type of a pivot source field. */
export enum PivotFieldTypeEnum {
  Number = 'number',
  String = 'string',
  Date = 'date',
}
